import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const PhysicalItems = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerPadding: "80px",
    autoplay: true,
    autoplaySpeed: 20000,
    responsive: [
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 787,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  };
  const physicalItems = [
    {
      firstImg: "../../../assets/images/physicalproduct/img1.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/physicalproduct/img2.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/physicalproduct/img3.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/physicalproduct/img4.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/physicalproduct/img1.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/physicalproduct/img2.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/physicalproduct/img3.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/physicalproduct/img4.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
  ];
  return (
    <Slider {...settings}>
      {physicalItems.map((item, index) => {
        return (
          <Link
            to="/physicaldetail"
            className="custom-link"
            style={{ color: "transparent" }}
            key={index}
          >
            <div className="top-phy-wrap">
              <div className="top-raffle-single">
                <div className="heart-love text-end">
                  <div className="icon-wrapping-hears">
                    <Icon
                      icon="ant-design:heart-filled"
                      className="heart-icon-sinlge"
                    />
                    <span>1.2k</span>
                  </div>
                </div>
                <img className="top-raffle-single-img" src={item.firstImg} />
                <div className="d-flex align-items-center top-raffle-first">
                  <img className="top-raffle-prof-imgp" src={item.profImg} />

                  <h3 className="raffle-it">{item.title}</h3>
                </div>

                <div className="d-flex align-items-center justify-content-between top-raffle-second">
                  <h3 className="instock">
                    in stock <span>{item.inStock}</span>
                  </h3>
                  <div className="d-flex align-items-center justify-content-between price">
                    <h3 className="price-tit">
                      price:
                      <img
                        className="etheriumico"
                        src="../../../assets/images/topraffle/img4.png"
                      />
                      <span>{item.price}</span>
                    </h3>
                  </div>
                </div>
                <div className="forborder-bott"></div>

                <div className="d-flex align-items-center bottom-items justify-content-between top-raffle-third">
                  <div className="d-flex align-items-center">
                    <img className="top-raffle-prof-imgp" src={item.userImg} />

                    <h3 className="seller-name">{item.userName}</h3>
                  </div>
                  <div>
                    <button className="place-bid">Place bid</button>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        );
      })}
    </Slider>
  );
};
export default PhysicalItems;
